import React from "react";
import UpdateWidget from "../../utils/UpdateWidget";
import UploadInputField from "../../utils/UploadInputField";
import Spinner from "react-spinner-material";
import Loader from "../../components/Loader/Loader";
import { PropTypes } from "prop-types";

const Docs = ({
  isFetching,
  handleDataFetch,
  handleRemoval,
  isUpdating,
  updateDocs,
  categoryDocs,
}) => {
  return (
    <div>
      {isFetching ? (
        <div className="center-spinner2">
          <br />
          <Spinner
            size={120}
            color={"#047558"}
            spinnerwidth={5}
            visible={true}
          />
        </div>
      ) : (
          <div>
              <div>
                <div className="upload-files">
                  {categoryDocs &&
                    categoryDocs.map((category) => (
                      (category.type === "url" &&
                        <UpdateWidget
                          id={category.id}
                          loaded={category.loaded}
                          url={category.url}
                          key={category.name}
                          title={category.title}
                          handleDataFetch={handleDataFetch}
                          name={category.name}
                          handleRemoval={handleRemoval}
                        />)
                    ))}
                </div>

                <div className="upload-file-input">
                  {categoryDocs && categoryDocs.map((category) => (
                    (category.type === "input" &&
                      <UploadInputField
                        id={category.id}
                        key={category.id}
                        url={category.url}
                        name={category.name}
                        handleDataFetch={handleDataFetch}
                        title={category.title}
                      />
                    )
                  ))}
                </div>
              </div>

            <div className="upload-button">
              <button onClick={() => updateDocs()} disabled={isUpdating}>
                {isUpdating ? <Loader /> : "UPDATE"}
              </button>
            </div>
          </div>
        )}
    </div>
  );
};

Docs.propTypes = {
  categoryDocs: PropTypes.array,
  handleDataFetch: PropTypes.func,
  handleRemoval: PropTypes.func,
  isFetching: PropTypes.bool,
  isUpdating: PropTypes.bool,
  updateDocs: PropTypes.func
}

export default Docs;
